import head from 'lodash/head';

const getFirstLetter = text => {
  if (!text) return '?';
  return head(text)?.toUpperCase();
};

export default getFirstLetter;
